// src/modules/app-views/ticket-events/pages/Document/actions/actionButton.js
import { SaveOutlined } from '@ant-design/icons';

const ticketEventsDocumentActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: <SaveOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ moduleContext }) => moduleContext?.formContext?.submitForm?.(),
    dropdownItems: [],
  };
};

export default ticketEventsDocumentActionButton;
